import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {AccountingEntry, AccountingEntrySearchParams} from '@accounting/_common/models/accounting-entry.models';

export const CheckState = createAction(
    '[AccountingEntries] Check State',
    props<{ payload: { modalView: boolean, close: boolean, items: AccountingEntry[] } }>()
);

export const CheckStateSuccess = createAction(
    '[AccountingEntries] Check State Success',
    props<{ payload: { modalView: boolean, close: boolean, items: AccountingEntry[] } }>()
);

export const LoadList = createAction(
    '[AccountingEntries] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[AccountingEntries] Load List Success',
    props<{ payload: { items: AccountingEntry[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[AccountingEntries] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetPagination = createAction(
    '[AccountingEntries] Set Pagination',
    props<{ payload: boolean }>()
);

export const SetFilter = createAction(
    '[AccountingEntries] Set Filter',
    props<{ payload: AccountingEntrySearchParams }>()
);

export const SetLoading = createAction(
    '[AccountingEntries] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[AccountingEntries] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const UpdateItemSuccess = createAction(
    '[AccountingEntries] Update Item Success',
    props<{ payload: AccountingEntry }>()
);

export const DeleteItem = createAction(
    '[AccountingEntries] Delete Item',
    props<{ payload: AccountingEntry }>()
);

export const DeleteItemSuccess = createAction(
    '[AccountingEntries] Delete Item Success',
    props<{ payload: AccountingEntry }>()
);

export const DeleteItemFailure = createAction(
    '[AccountingEntries] Delete Item Failure',
    props<{ payload: AccountingEntry }>()
);

export const SetInitialState = createAction(
    '[AccountingEntries] Set Initial State'
);
